"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuLink = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(MenuLink, _Component);

  function MenuLink() {
    (0, _classCallCheck3.default)(this, MenuLink);
    return (0, _possibleConstructorReturn3.default)(this, (MenuLink.__proto__ || (0, _getPrototypeOf2.default)(MenuLink)).apply(this, arguments));
  }

  (0, _createClass3.default)(MenuLink, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          link = _props.link,
          text = _props.text,
          handleClick = _props.handleClick,
          className = _props.className,
          small = _props.small,
          mobileOnly = _props.mobileOnly,
          noActive = _props.noActive;
      var icon = this.props.icon;

      var classNames = "menu-link";

      if (!icon) {
        icon = null;
      } else {
        classNames += " menu-link-light";
      }

      if (small) {
        classNames += " menu-link-small";
      }

      if (mobileOnly) {
        classNames += " menu-link-mobile-only";
      }

      if (className) {
        classNames += " " + className;
      }

      return _react2.default.createElement(
        "li",
        { className: classNames },
        _react2.default.createElement("i", { className: icon }),
        _react2.default.createElement(
          _reactRouter.Link,
          {
            to: link,
            onClick: handleClick,
            activeClassName: !noActive ? "menu-link-active" : "",
            onlyActiveOnIndex: true
          },
          text
        )
      );
    }
  }]);
  return MenuLink;
}(_react.Component), _class.propTypes = {
  link: _react.PropTypes.string.isRequired,
  text: _react.PropTypes.string.isRequired,
  icon: _react.PropTypes.string,
  handleClick: _react.PropTypes.func,
  className: _react.PropTypes.string,
  small: _react.PropTypes.boolean,
  mobileOnly: _react.PropTypes.boolean,
  noActive: _react.PropTypes.boolean
}, _temp);
exports.default = MenuLink;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/menu/MenuLink.js
 ** module id = 1160
 ** module chunks = 0
 **/